var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEducationColor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "190px",
    height: "150px",
    viewBox: "0 0 190 150",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Illustration/EducationColor") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1.05104327e-07%",
    y1: "22.3693114%",
    x2: "99.999575%",
    y2: "27.7870935%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9768A6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9768A6",
    offset: "14.0625%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8786C9",
    offset: "53.6458313%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5771B8",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-18.6%",
    y: "-23.4%",
    width: "137.3%",
    height: "146.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M70.1096191,2.48608398 C75.8480225,-0.828674316 85.1519775,-0.828704834 90.8903809,2.48605347 L156.696167,40.4981079 C159.785645,42.2827148 161.211792,44.6642761 160.974609,47 L161,47 L161,82 L160.974609,82 C160.77124,84.0027161 159.345093,85.9717407 156.696167,87.5018921 L90.8903809,125.513947 C85.1519775,128.828705 75.8480225,128.828705 70.1096191,125.513947 L4.30383301,87.5018921 C1.65490723,85.9717407 0.228759766,84.0027161 0.025390625,82 L0,82 L0,47 L0.025390625,47 C-0.211791992,44.6642761 1.21435547,42.2827148 4.30383301,40.4981079 L70.1096191,2.48608398 Z",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-5.3%",
    y: "-6.6%",
    width: "110.6%",
    height: "113.3%",
    filterUnits: "objectBoundingBox",
    id: "filter-4"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.5,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "17.0391058%",
    y1: "48.8133345%",
    x2: "93.8547498%",
    y2: "50.7911126%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A25EBA",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F5EBF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "4.84848571%",
    y1: "49.4736888%",
    x2: "96.9696952%",
    y2: "49.4736878%",
    id: "linearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#918ABD",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#878ED1",
    offset: "56.25%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AF81C4",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M156.696167,40.4980965 L90.8903961,2.48606777 C88.1346946,0.894265175 84.3971584,0 80.5,0 C76.6028569,0 72.8653209,0.894265652 70.1096191,2.48606849 L4.30384064,40.4981003 C1.54813886,42.0899031 0,44.2488511 0,46.5 C0,48.7511489 1.54813814,50.9100971 4.30383968,52.5018997 L70.1096191,90.5139313 C72.8653207,92.1057339 76.6028492,93 80.5,93 C84.3971508,93 88.1346867,92.1057265 90.8903885,90.5139236 L156.696167,52.5018959 C159.451869,50.9100931 161,48.7511451 161,46.5 C161,44.2488472 159.451869,42.0898991 156.696167,40.4980965 Z M14.6942263,46.5 L23.6645947,41.3183594 C24.8440592,41.998349 25.7797959,42.8060211 26.4182453,43.6951523 C27.0566947,44.5842835 27.3853207,45.5374185 27.3853207,46.5 C27.3853206,47.4625815 27.0566911,48.4157127 26.4182415,49.3048439 C25.779792,50.1939752 24.8440593,51.0016509 23.6645947,51.6816406 L14.6942263,46.5 Z M32.6695938,56.693222 L32.4531288,56.5681839 C31.799039,56.1931878 31.4128362,55.689882 31.3711357,55.1580963 C31.3294352,54.6263106 31.6352841,54.1048958 32.2280045,53.6972771 C35.0383563,51.647624 36.5675429,49.1096482 36.567543,46.4949951 C36.5675432,43.880342 35.0383561,41.34237 32.2280045,39.292717 C31.5976377,38.8609405 31.2900245,38.3022014 31.372839,37.7394142 C31.4556534,37.176627 31.9221097,36.655892 32.6695938,36.2917671 C33.4170779,35.9276422 34.3843587,35.7499537 35.3586464,35.7977905 C36.3329341,35.8456274 37.2344251,36.1150718 37.8647919,36.5468483 C41.8110547,39.3605809 43.9636737,42.8721533 43.9620972,46.4933815 C43.9605206,50.1146097 41.8048408,53.6255546 37.8561287,56.4381409 C37.5451208,56.6520739 37.1640445,56.8284269 36.7347641,56.9570847 C36.3054837,57.0857424 35.8364471,57.1641744 35.3545685,57.1878738 C34.8726899,57.2115733 34.3874525,57.1800765 33.9266968,57.095192 C33.4659411,57.0103074 33.0387369,56.8737043 32.6695938,56.693222 Z M45.0601311,63.8504868 L44.8350029,63.7204437 C44.179721,63.3445506 43.7935743,62.8398864 43.7534599,62.3069382 C43.7133456,61.77399 44.022208,61.2518629 44.6185379,60.8445358 C56.2211361,52.9320316 56.2211332,40.0679622 44.6878052,32.1754646 C44.0574384,31.7436882 43.7498309,31.1849471 43.8326454,30.62216 C43.9154599,30.0593728 44.3819143,29.5386416 45.1293983,29.1745167 C45.8768824,28.8103918 46.8441632,28.6327032 47.8184509,28.6805401 C48.7927386,28.728377 49.6942258,28.9978195 50.3245926,29.4295959 C64.0831947,38.8475761 64.0831957,54.162425 50.3245926,63.5804062 C50.0119914,63.79655 49.6280273,63.9745792 49.1950874,64.104126 C48.7621475,64.2336727 48.2888911,64.3121419 47.8029137,64.3349533 C47.3169363,64.3577647 46.8279595,64.3244619 46.3644905,64.2369919 C45.9010215,64.1495219 45.472334,64.0096355 45.1034203,63.8254814 L45.0601311,63.8504868 Z M79.7596732,31.7180538 L106.454197,36.2485252 C107.07801,36.3543959 107.614932,36.7492116 107.901949,37.3131023 L115.262566,51.7742439 C115.51309,52.2664392 115.317176,52.868532 114.824981,53.1190559 C114.633446,53.216546 114.415598,53.249735 114.203721,53.2137047 L87.5085666,48.6741172 C86.8851804,48.5681086 86.348646,48.1735401 86.0616767,47.6100716 L78.7012593,33.1577804 C78.450619,32.6656444 78.64639,32.0635052 79.138526,31.8128649 C79.3300103,31.7153437 79.5478153,31.6820983 79.7596732,31.7180538 Z M72.1585969,42.7056 L76.5735125,40.1553701 C77.0517452,39.879124 77.6633712,40.0428664 77.9396173,40.5210992 C77.9484927,40.5364642 77.9569577,40.5520627 77.965003,40.5678781 L82.5723105,49.6248364 C82.8592055,50.1888092 83.3960588,50.5837537 84.0198679,50.6897547 L99.1614013,53.2626844 C99.7058812,53.3552053 100.072266,53.8715965 99.9797454,54.4160763 C99.929875,54.7095607 99.7518412,54.9655677 99.4940652,55.1144693 L95.5497834,57.3928425 C95.1461943,57.6259716 94.6738565,57.7108247 94.2143602,57.6327448 L77.0496535,54.7160302 C76.4258441,54.6100293 75.8889906,54.2150846 75.6020956,53.6511116 L71.3763672,45.3442514 C70.8942939,44.3966005 71.2379366,43.2374098 72.1585969,42.7056 Z M86.4831314,81.0559235 C84.8931425,81.9690857 82.7421315,82.4816589 80.5,82.4816589 C78.2578685,82.481659 76.1068574,81.9690856 74.5168686,81.0559235 L58.2992096,71.6879654 C57.5099324,71.2294084 57.0669059,70.6090518 57.066906,69.9624176 C57.066906,69.3157834 57.5099285,68.6954345 58.2992058,68.2368774 C59.0922652,67.778771 60.1674273,67.5209953 61.2889862,67.5200577 C62.4105451,67.5191201 63.4869971,67.775094 64.2823486,68.2318726 L79.6341324,77.0996704 C79.8637742,77.2323206 80.1752374,77.3068466 80.5,77.3068466 C80.8247626,77.3068466 81.1362258,77.2323207 81.3658676,77.0996704 L133.473648,47.0001488 C133.70329,46.8674985 133.832306,46.6875881 133.832306,46.5 C133.832306,46.3123966 133.70329,46.1324824 133.473648,45.9998322 L81.3658676,15.9003124 C81.1362258,15.7676622 80.8247702,15.69314 80.5,15.69314 C80.1752451,15.69314 79.8637818,15.7676631 79.63414,15.9003134 L63.386631,25.2855186 C62.5798477,25.7039483 61.5260503,25.927787 60.4421806,25.9109516 C59.3583109,25.8941163 58.3268579,25.6378905 57.5601692,25.1950207 C56.7934806,24.7521509 56.3499077,24.1563443 56.3207626,23.5302582 C56.2916175,22.9041721 56.6791214,22.2954559 57.4034996,21.8294258 L74.5168762,11.9440613 C76.1068652,11.030899 78.2578762,10.5183316 80.5,10.5183315 C82.7421391,10.5183315 84.8931426,11.0308992 86.4831314,11.9440613 L140.322662,43.0438995 C141.903513,43.9623401 142.790848,45.2048482 142.790848,46.5 C142.790848,47.7951366 141.903513,49.0376446 140.322662,49.9560852 L86.4831314,81.0559235 Z",
    id: "path-7"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-0.9%",
    y: "-1.6%",
    width: "101.9%",
    height: "103.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-8"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: -1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Illustration/EducationColor",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-121",
    transform: "translate(14.500000, 0.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.1096191,12.486084 C75.8480225,9.17132568 85.1519775,9.17129517 90.8903809,12.4860535 L156.696167,50.4981079 C159.785645,52.2827148 161.211792,54.6642761 160.974609,57 L161,57 L161,92 L160.974609,92 C160.77124,94.0027161 159.345093,95.9717407 156.696167,97.5018921 L90.8903809,135.513947 C85.1519775,138.828705 75.8480225,138.828705 70.1096191,135.513947 L4.30383301,97.5018921 C1.65490723,95.9717407 0.228759766,94.0027161 0.025390625,92 L0,92 L0,57 L0.025390625,57 C-0.211791992,54.6642761 1.21435547,52.2827148 4.30383301,50.4981079 L70.1096191,12.486084 Z",
    id: "Glow",
    fill: "url(#linearGradient-1)",
    opacity: 0.699999988,
    filter: "url(#filter-2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Union"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-1)",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-4)",
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M70.3195135,2.37914062 C75.6658962,-0.793046713 84.3341038,-0.793046951 89.6804865,2.37914014 L150.990209,38.7562447 C156.336593,41.9284327 156.336592,47.0715637 150.990209,50.2437515 L89.6804801,86.6208572 C84.3341018,89.7930422 75.6658978,89.7930529 70.3195135,86.6208649 L9.00978755,50.2437553 C3.66340442,47.071568 3.66340361,41.9284332 9.00978796,38.7562447 L70.3195135,2.37914062 Z",
    id: "Subtract",
    fill: "url(#linearGradient-5)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-14",
    fillOpacity: 0.230000004,
    fill: "#000000",
    points: "66.5 42.9777832 84.1875 25.7053223 133.5 46.7277832 133.5 65.0402832 84.1875 87.0803223 53.1279297 72.8081055"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-6)",
    xlinkHref: "#path-7"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-8)",
    xlinkHref: "#path-7"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducationColor);
export default __webpack_public_path__ + "static/media/EducationColor.699f46a86cb903f7c07a328a91b1d0e3.svg";
export { ForwardRef as ReactComponent };